import type { AppRouteModule } from '/@/router/types';

const graphicTextFission: AppRouteModule = {
  path: '/graphic-text-fission',
  name: 'graphicTextFission',
  component: () => import('/@/layouts/graphicText/fission.vue'),
  meta: {},
  children: [
    {
      path: '/graphic-text-fission/template',
      name: 'GraphicTextFissionTemplate',
      meta: {
        title: '图文模板管理',
      },
      component: () => import('/@/views/graphic-text-fission/template-manage/index.vue'),
    },
    {
      path: '/graphic-text-fission/export',
      name: 'GraphicTextFissionExport',
      meta: {
        title: '图文导出任务管理',
      },
      component: () => import('/@/views/graphic-text-fission/export-manage/index.vue'),
    },
    {
      path: '/graphic-text-fission/font',
      name: 'GraphicTextFissionFont',
      meta: {
        title: '图文字体管理',
      },
      component: () => import('/@/views/graphic-text-fission/font-manage/index.vue'),
    },
    {
      path: 'member',
      name: 'GraphicTextFissionMember',
      meta: {
        title: '成员管理',
      },
      props() {
        return {
          inviteUrlQuery: 'toCreation=2',
        };
      },
      component: () => import('/@/views/member/index.vue'),
    },
    {
      path: 'account',
      name: 'GraphicTextFissionAccount',
      meta: {
        title: '账号中心',
      },
      component: () => import('/@/views/account/index.vue'),
    },
    {
      path: 'lingdou',
      name: 'GraphicTextFissionLingdou',
      meta: {
        title: '灵豆记录',
      },
      component: () => import('/@/views/commerce/lingdou/index.vue'),
    },
  ],
};

export default graphicTextFission;
